<template>
	<div>
		<div
			v-if="/jpg|jpeg|png/gi.test(selectedFile.originalFilename)"
			class="imgWrapper"
		>
			<imgViewer :selectedFile="selectedFile" />
		</div>
		<div
			v-if="
				/pdf/i.test(selectedFile.originalFilename) &&
					/xl/gi.test(selectedFile.extension)
			"
			class="pdfWrapper"
		>
			<pdfViewer :selectedFile="selectedFile" :isOriginalFile="true" />
		</div>
		<div v-if="/pdf/i.test(selectedFile.extension)" class="pdfWrapper">
			<pdfViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/xl/gi.test(selectedFile.extension)" class="xlsxWrapper">
			<xlsxViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/txt/gi.test(selectedFile.extension)" class="txtWrapper">
			<txtViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/csv/gi.test(selectedFile.extension)" class="csvWrapper">
			<csvViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/html/gi.test(selectedFile.extension)" class="htmlWrapper">
			<htmlViewer :selectedFile="selectedFile" />
		</div>
		<v-btn
			color="green darken-1"
			small
			absolute
			top
			right
			fab
			@click="downloadOriginalFile"
		>
			<v-icon>get_app</v-icon>
		</v-btn>
		<v-btn
			color="orange darken-1"
			small
			absolute
			top
			left
			fab
			@click="downloadActualFileFromServer"
		>
			<v-icon color="white">get_app</v-icon>
		</v-btn>
	</div>
</template>

<script>
import pdfViewer from '../../components/pdfViewer';
import xlsxViewer from '../../components/xlsxViewer';
import txtViewer from '../../components/textViewer';
import csvViewer from '../../components/csvViewer';
import htmlViewer from '../../components/htmlViewer';
import imgViewer from '../../components/imageViewer';
import { mapGetters, mapActions } from 'vuex';
export default {
	created() {},
	components: {
		pdfViewer,
		xlsxViewer,
		txtViewer,
		csvViewer,
		htmlViewer,
		imgViewer,
	},
	data() {
		return {};
	},
	methods: {
		...mapActions('aiMetaMap', ['downloadFile', 'downloadActualFile']),
		downloadOriginalFile() {
			this.downloadFile().then(() => {});
		},
		downloadActualFileFromServer() {
			this.downloadActualFile().then(() => {});
		},
	},
	computed: {
		...mapGetters('aiMetaMap', ['selectedFile']),
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.pdfWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.xlsxWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.txtWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.csvWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.htmlWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}

.imgWrapper {
	display: flex;
	flex-direction: column;
	max-width: 100%;
	align-items: center;

	img {
		max-width: 100%;
	}
}
</style>
